import useBreakpoint from 'shared/lib/hooks/useBreakpoint';

import {shouldShowAddPaymentButton} from '../lib/addPaymentButton';

const useShowAddPaymentButton = () => shouldShowAddPaymentButton(useBreakpoint());

export default useShowAddPaymentButton;
